// extracted by mini-css-extract-plugin
export default {"container":"XZ_1wnF06cDs8Pdahy2q","text":"WHLRU6kR4VJEIJcVYtsP"};